export interface InlineImageProperties {
    url?: string;
    width?: string;
    height?: string;
    _class?: string;
}

export const EditImageCommand = "images.edit-image";
